import { useState } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { getSessionId } from '../utils/sessionId';
import menuStore from '../utils/localForageInstance';

const useEditCartItem = (editOrderId = null) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const openEditModal = async (clickedCartItem) => {
    try {
      const session_id = getSessionId();

      let url = apiUrls.CART_ITEM_DETAILS + `?session_id=${session_id}`;
      if (editOrderId) {
        url += `&edit_order_id=${editOrderId}`;
      }
      const response = await callAPI(url, {}, 'GET');

      const cartItems = response?.data?.data?.items || [];

      const matchedCartItem = cartItems.find(
        (item) => item.cart_id === clickedCartItem.cart_id
      );

      if (!matchedCartItem) return;

      const productData = await menuStore.getItem(
        `product_${matchedCartItem.item_id}`
      );

      if (!productData) return;

      setSelectedItem({
        ...matchedCartItem,
        fullProductData: productData
      });

      setModalOpen(true);
    } catch (err) {
      console.error('Edit cart error:', err);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  return {
    selectedItem,
    isModalOpen,
    openEditModal,
    closeModal
  };
};

export default useEditCartItem;
